import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spin, Row, Col, Button, Modal, Drawer, Tooltip, message, Divider } from 'antd';
import { LeftOutlined, RedoOutlined, DeleteOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { isEmpty, find } from 'lodash';

import {
    loadActivityDetails, updateActivityDetails, deleteActivityDetailItem
} from '../actions';
import * as constants from '../constants';
import ActivityForm from './ActivityForm';

import common from '../../../common';
import currentuser from '../../currentuser';
import core from '../../core';
import globalappstate from '../../globalappstate';
import uistate from '../../uistate';
import dossier from '../../dossier';
import changelog from '../../changelog';
import workflow from '../../workflow';
import currentUserHasRights from '../../../common/currentUserHasRights';

const { LogbookGrid } = workflow;

class ActivityDetails extends Component {

    state = {
        selectedIdProcessingActivity: '',
        refreshcount: 0,
        showLogDrawer: false,
    }

    UNSAFE_componentWillMount() {
        if (this.props.repId) { //render als popup
            this.setState({
                selectedIdProcessingActivity: this.props.repId,
            },
                () => this.refreshDetailActivity());
        } else { //render as page (url)
            this.setState({
                selectedIdProcessingActivity: this.props.match.params.repId,
            },
                () => this.refreshDetailActivity());
        }
    }

    refreshDetailActivity = async () => {
        // console.log('refresh:',this.state.selectedIdProcessingActivity);
        let details = await this.props.loadActivityDetails(this.state.selectedIdProcessingActivity);
        this.props.loadDossierFiles(details.processingActivity.idDossier);
        this.props.loadChangelog(details.processingActivity.idProcessingActivity);
    }

    refreshActivity = async => {
        if (this.props.selectedDetailActivityIsDirty) {
            if (window.confirm(this.label("UnsavedChanges"))) {
                this.setState(state => ({
                    refreshcount: state.refreshcount + 1,
                }));
                this.refreshDetailActivity();
            }
        } else {
            this.setState(state => ({
                refreshcount: state.refreshcount + 1,
            }));
            this.refreshDetailActivity();
        }
    }

    saveClicked = async (activity) => {
        await this.props.updateActivityDetails(activity);
        await this.refreshDetailActivity();
    }

    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'ActivityDetails', key);
    }

    navigateBack = async () => {
        this.props.history.goBack();
    }
    onDelete = async () => {
        if (this.props.selectedDetailActivity.processingActivity.idProcessingActivityStatus != 10) {
            await this.props.deleteActivityDetailItem(this.state.selectedIdProcessingActivity);
            this.navigateBack();
        } else {
            message.error(this.label("NotAllowedForStatus"));
        }
    }
    showLogDrawer = () => {
        this.setState({
            showLogDrawer: true,
        });
    };
    onCloseLogDrawer = () => {
        this.setState({
            showLogDrawer: false,
        });
    };
    calculateCurrentUserMutateRights = () => {
        let result = false;
        if (
            this.props.currentuser.idUser == this.props.selectedDetailActivity.processingActivity.idResponsiblePerson
            || currentUserHasRights([common.rights.IsCompliancyEmployee], this.props.selectedDetailActivity.processingActivity.idCompany)
            || this.props.currentuser.upn == this.props.selectedDetailActivity.processingActivity.redirectedToUPN
        ) {
            result = true;
        }
        return result;
    }

    render() {
        const menuHeight = 45;
        const gridHeight = this.props.contentHeight - menuHeight;

        let userHasMutateRights = false;
        let showform = !isEmpty(this.props.selectedDetailActivity);
        if (showform) {
            userHasMutateRights = this.calculateCurrentUserMutateRights();
        }

        return (
            <div className='incident' >
                <Row className='main-toolbar' style={{ height: menuHeight }} justify="start" align='middle' gutter={8}>
                    <Col >
                        <Button size='small' type="primary" onClick={this.navigateBack} style={{ marginLeft: 15, marginRight: 15 }} >
                            <LeftOutlined />{this.props.expId ? this.label("Close") : this.label("Back")}
                        </Button>

                        <span className='module-title'>{this.label("IncidentDetails")}</span>
                        <Button size='small' onClick={this.refreshActivity} style={{ marginLeft: 25 }} >
                            <RedoOutlined />{this.label("Refresh")}
                        </Button>
                        {this.props.selectedDetailActivity && this.props.selectedDetailActivity.processingActivity && this.props.selectedDetailActivity.processingActivity.workflowInstanceId &&
                            <Button size='small' onClick={this.showLogDrawer} style={{ marginLeft: 10 }} >
                                <UnorderedListOutlined />{this.label("ReportWorkflowLog")}
                            </Button>
                        }
                        {this.props.selectedDetailActivity && this.props.selectedDetailActivity.processingActivity && currentUserHasRights([common.rights.IsCompliancyEmployee], this.props.selectedDetailActivity.processingActivity.idCompany) &&
                            <Button size='small' onClick={this.onDelete} style={{ marginLeft: 50 }} >
                                <DeleteOutlined />{this.label("Delete")}
                            </Button>
                        }
                    </Col>
                </Row>

                <Spin size="large" spinning={this.props.loadingDetails}>
                    {showform &&
                        <ActivityForm key={`${this.props.selectedDetailActivity.processingActivity.idProcessingActivity}:${this.state.refreshcount}`}
                            contentheight={gridHeight}
                            datacontext={this.props.selectedDetailActivity}
                            contentHeight={this.props.contentHeight} contentWidth={this.props.contentWidth}
                            onSave={this.saveClicked} readOnly={!userHasMutateRights}
                            onRefresh={this.refreshActivity} onCancel={this.refreshActivity} onRedirect={this.navigateBack} />
                    }
                </Spin>
                {showform &&
                    <Drawer destroyOnHidden={true} width='50%' title={this.label("ReportWorkflowLog")} placement="left" closable={true} onClose={this.onCloseLogDrawer} open={this.state.showLogDrawer} mask={true} maskClosable={true}>
                        <LogbookGrid workflowInstanceId={this.props.selectedDetailActivity.processingActivity.workflowInstanceId} />
                    </Drawer>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        selectedDetailActivity: state[constants.NAME].selectedDetailActivity,
        loadingDetails: state[constants.NAME].loadingDetails,
        contentHeight: state[uistate.constants.NAME].contentheight,
        contentWidth: state[uistate.constants.NAME].contentwidth,
        labels: uistate.selectors.uiLabels(state),
        selectedDetailActivityIsDirty: state[constants.NAME].selectedDetailActivityIsDirty,
        picklists: globalappstate.selectors.allPicklists(state),
        currentuser: state[currentuser.constants.NAME],
    };
}

export default connect(mapStateToProps,
    {
        loadActivityDetails, updateActivityDetails, deleteActivityDetailItem,
        loadDossierFiles: dossier.actions.loadDossierFiles,
        loadChangelog: changelog.actions.loadChangelog
    })(ActivityDetails);